import { cookie } from '@kk/utils';

export async function getCurrentLoginUser() {
    const session = cookie.get('session') || cookie.get('passToken') || '';
    if (!session) return null;

    const uid = Number(cookie.get('uid') || 0);
    return {
        uid,
        status: 1,
        session,
        passToken: session,
    };
}
